// extracted by mini-css-extract-plugin
module.exports = {"row":"NewAttribute_row__1HtrA","col":"NewAttribute_col__85TcC","card":"NewAttribute_card__3KgmI"};